import React, { useState } from "react";
import { useWindowDimensions } from "react-native"; // Import useWindowDimensions
import "./Home.css";
import "./Footer.css";
import Marquee from "react-fast-marquee";
import flagsImage from "./flag.png";
import axios from "axios";

function Footer() {
  const [Email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const { width } = useWindowDimensions(); // Get window dimensions
  const isMobile = width < 991; // Determine if the device is mobile

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("https://keepityourself.com/wp-json/newsletter/v1/subscribers", {
        Email,
      });

      setStatus("Thanks for subscribing!");
      setEmail("");
    } catch (error) {
      console.error("Error subscribing:", error.response?.data || error.message);
      setStatus("Subscription failed. Try again.");
    }
  };

  return (
    <>
      <div className="logosection">
        <br />
        <div className="heading">Recognized Worldwide, Proven <br className="responsive-br" />Technology</div>
        <br  className="responsive-br"/>
        <div className="ki-yholdspatentsacross-20-countriesensuringourtechstayssecurecutting-edgeandgloballyreliable">
          KIY holds patents across 20+ countries, ensuring our tech stays <br className="responsive-br"/>secure, cutting-edge, and globally reliable.
        </div>
        <br />
        <div
          style={{
            width: isMobile ? "100%" : "80%",
            overflow: "hidden",
            height: isMobile ? "40px" : "80px", // should fit the image
            position: "relative", // just in case
            zIndex: 1,
          }}
        >
          <Marquee
            gradient
            gradientColor="rgba(1, 23, 30, 1)"
            speed={isMobile ? 100 : 150}
          >
          <img
            loading="eager"
            src={flagsImage}
            alt="Flags"
            className="flags-image"
            style={{
              // objectFit: "contain",
              // height: isMobile ? "30px" : "70px",
              objectFit: "contain",
              height: isMobile ? "30px" : "70px",
              willChange: "transform",
              backfaceVisibility: "hidden",
              transform: "translateZ(0)",
              display: "block", // Ensure the image is displayed as a block element
            }}
          />
        </Marquee>
        </div>
        <br className="responsive-br"/>
        <br className="responsive-br"/>
        <br  className="responsive-br"/>
      </div>
      <div className="footer">
        <div className="footer-sea-wire-footer-09">
          <div className="div-3">
            <div className="column-4">
              <div className="div-4">
                <div className="div-5">
                  <div className="div-6">
                    <div className="column-5">
                      <div className="div-7">
                        <img
                          loading="lazy"
                          srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/0149d8037206926b38dc5900d25eb0992e405fec?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/0149d8037206926b38dc5900d25eb0992e405fec?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/0149d8037206926b38dc5900d25eb0992e405fec?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/0149d8037206926b38dc5900d25eb0992e405fec?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/0149d8037206926b38dc5900d25eb0992e405fec?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/0149d8037206926b38dc5900d25eb0992e405fec?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/0149d8037206926b38dc5900d25eb0992e405fec?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/0149d8037206926b38dc5900d25eb0992e405fec?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b"
                          className="img-16"
                          alt="Keep It Yourself Logo"
                        />
                        <br></br>
                        <br/>
                        <div className="announcementscanbefoundinourblog-presscontactpartnershipkeepityourselfcom">
                          Announcements can be found in our blog. Press
                          contact:
                          <br />
                          <a 
                            href="https://mail.google.com/mail/?view=cm&fs=1&to=partnership@keepityourself.com" 
                            style={{
                              textDecoration: "underline",
                              color: "white",
                              fontWeight: "regular",
                              fontSize: "16px",
                            }}
                          >
                            partnership@keepityourself.com
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="column-6">
                      <div className="div-8">
                        <div className="products">Products</div>
                        <div className="your-email">
                        <a href="/" style={{textDecoration: "none", color: "white" }}><br />KIY Seedless</a>
                          <br />
                          <br></br>
                          <br />
                          <a href="/" style={{textDecoration: "none", color: "white"}}>Crypto Security Services</a>
                        </div>
                      </div>
                    </div>
                    <div className="column-7">
                      <div className="div-9">
                        <div className="products">More</div>
                        <div className="your-email">
                          <a href="/" style={{textDecoration: "none", color: "white"}}><br />Blog</a>
                          <br />
                          <br></br>
                          <a href="/" style={{textDecoration: "none", color: "white"}}><br />Careers</a>
                          <br />
                          <br></br>
                          <a href="/" style={{textDecoration: "none", color: "white"}}><br />Knowledge Base</a>
                          <br />
                          <br></br>
                          <a href="/" style={{textDecoration: "none", color: "white"}}><br />Support</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {isMobile && (
                  <div className="div-11">
                    <div className="div-12">
                      <div className="products">Newsletter</div>
                      <div className="your-email">Your Email</div>
                      <input 
                        type="email" 
                        className="container-2" 
                        placeholder="Enter Your Email" 
                        required
                        value={Email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <div className="actions-2">
                        <button 
                          type="button" 
                          className="button-4" 
                          onClick={handleSubmit}
                        >
                          Subscribe
                        </button>
                      </div>
                    </div>
                    <br></br>
                    <br></br>
                  </div>
                )}
                <div className="div-10" style={{ position: "relative", zIndex: 1 }}>
                  <div style={{ backgroundColor: "white", display: "inline-block", padding: "5px", borderRadius: "50%" }}>
                    <a href="https://www.linkedin.com/showcase/kiy-keepityourself/" target="_blank" rel="noopener noreferrer">
                      <img
                        loading="lazy"
                        srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/5fb3d58ace2f835f1d865f427001281638929195?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/5fb3d58ace2f835f1d865f427001281638929195?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/5fb3d58ace2f835f1d865f427001281638929195?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/5fb3d58ace2f835f1d865f427001281638929195?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/5fb3d58ace2f835f1d865f427001281638929195?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/5fb3d58ace2f835f1d865f427001281638929195?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/5fb3d58ace2f835f1d865f427001281638929195?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/5fb3d58ace2f835f1d865f427001281638929195?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b"
                        className="img-17"
                        style={{
                          display: "block",
                          width: "25px",
                          height: "25px",
                          objectFit: "cover",
                        }}
                        alt="LinkedIn Logo"
                      />
                    </a>
                  </div>
                  <div style={{ backgroundColor: "white", display: "inline-block", padding: "5px", borderRadius: "50%" }}>
                    <a href="https://x.com/kiy_fast?t=P77WMc1pVfdjVtLo-ab-YA&s=09" target="_blank" rel="noopener noreferrer">
                      <img
                        loading="lazy"
                        srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/454da8afff5f2aa2d010568004304c9d4d3d394f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/454da8afff5f2aa2d010568004304c9d4d3d394f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/454da8afff5f2aa2d010568004304c9d4d3d394f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/454da8afff5f2aa2d010568004304c9d4d3d394f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/454da8afff5f2aa2d010568004304c9d4d3d394f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/454da8afff5f2aa2d010568004304c9d4d3d394f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/454da8afff5f2aa2d010568004304c9d4d3d394f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/454da8afff5f2aa2d010568004304c9d4d3d394f?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b"
                        className="img-18"
                        style={{
                          display: "block",
                          width: "25px",
                          height: "25px",
                          objectFit: "cover",
                        }}
                        alt="Twitter Logo"
                      />
                    </a>
                  </div>
                  <div style={{ backgroundColor: "white", display: "inline-block", padding: "5px", borderRadius: "50%" }}>
                    <a href="https://www.instagram.com/kiy_fast?igsh=MWVxcm1vc2toZGJhdg==" target="_blank" rel="noopener noreferrer">
                      <img
                        loading="lazy"
                        srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/100b4795c23d4fb1865de3087a0868319bcb1c87?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/100b4795c23d4fb1865de3087a0868319bcb1c87?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/100b4795c23d4fb1865de3087a0868319bcb1c87?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/100b4795c23d4fb1865de3087a0868319bcb1c87?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/100b4795c23d4fb1865de3087a0868319bcb1c87?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/100b4795c23d4fb1865de3087a0868319bcb1c87?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/100b4795c23d4fb1865de3087a0868319bcb1c87?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/100b4795c23d4fb1865de3087a0868319bcb1c87?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b"
                        className="img-19"
                        style={{
                          display: "block",
                          // borderRadius: "50%",
                          width: "25px",
                          height: "25px",
                          objectFit: "cover",
                        }}
                        alt="Instagram Logo"
                      />
                    </a>
                  </div>
                  <div style={{ backgroundColor: "white", display: "inline-block", padding: "5px", borderRadius: "50%" }}>
                    <a href="https://www.youtube.com/@kiykeepityourself5919" target="_blank" rel="noopener noreferrer">
                      <img
                        loading="lazy"
                        srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/5db7581d9326ec637412609948717832ea31a186?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/5db7581d9326ec637412609948717832ea31a186?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/5db7581d9326ec637412609948717832ea31a186?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/5db7581d9326ec637412609948717832ea31a186?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/5db7581d9326ec637412609948717832ea31a186?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/5db7581d9326ec637412609948717832ea31a186?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/5db7581d9326ec637412609948717832ea31a186?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/5db7581d9326ec637412609948717832ea31a186?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b"
                        className="img-20"
                        style={{
                          display: "block",
                          width: "25px",
                          height: "25px",
                          objectFit: "cover",
                        }}
                        alt="YouTube Logo"
                      />
                    </a>
                  </div>
                  <div style={{ backgroundColor: "white", display: "inline-block", padding: "5px", borderRadius: "50%" }}>
                    <a href="https://t.me/fastandsafetechnology" target="_blank" rel="noopener noreferrer">
                      <img
                        loading="lazy"
                        srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/812ab244c8d29da9eecf47bcf1f31ed4734c6042?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/812ab244c8d29da9eecf47bcf1f31ed4734c6042?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/812ab244c8d29da9eecf47bcf1f31ed4734c6042?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/812ab244c8d29da9eecf47bcf1f31ed4734c6042?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/812ab244c8d29da9eecf47bcf1f31ed4734c6042?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/812ab244c8d29da9eecf47bcf1f31ed4734c6042?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/812ab244c8d29da9eecf47bcf1f31ed4734c6042?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/812ab244c8d29da9eecf47bcf1f31ed4734c6042?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b"
                        className="img-21"
                        style={{
                          display: "block",
                          // borderRadius: "50%",
                          width: "25px",
                          height: "25px",
                          objectFit: "cover",
                        }}
                        alt="Telegram Logo"
                      />
                    </a>
                  </div>
                  <div style={{ backgroundColor: "white", display: "inline-block", padding: "5px", borderRadius: "50%" }}>
                    <a href="https://github.com/KIY-FAST/kiy_core_api " target="_blank" rel="noopener noreferrer">
                      <img
                        loading="lazy"
                        srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/b5ce1042c1bb4c36fcd67e77b0e886db2b103f3d?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/b5ce1042c1bb4c36fcd67e77b0e886db2b103f3d?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/b5ce1042c1bb4c36fcd67e77b0e886db2b103f3d?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/b5ce1042c1bb4c36fcd67e77b0e886db2b103f3d?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/b5ce1042c1bb4c36fcd67e77b0e886db2b103f3d?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/b5ce1042c1bb4c36fcd67e77b0e886db2b103f3d?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/b5ce1042c1bb4c36fcd67e77b0e886db2b103f3d?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/b5ce1042c1bb4c36fcd67e77b0e886db2b103f3d?placeholderIfAbsent=true&apiKey=e575051869da42d9bfd064276f858a0b"
                        className="img-22"
                        style={{
                          display: "block",
                          // borderRadius: "50%",
                          width: "25px",
                          height: "25px",
                          objectFit: "cover",
                        }}
                        alt="GitHub Logo"
                      />
                    </a>
                  </div>
                </div>
                <div className="keep-it-yourself-all-rights-reserved">
                  © 2025 Keep It Yourself. All Rights Reserved.
                  {isMobile && (
                    <div style={{marginTop: "8px"}}>Terms of Service<span style={{marginLeft: "5%"}}>Privacy Policy</span></div>
                  )}
                </div>
              </div>
            </div>
            {!isMobile && (
            <div className="column-8">
              <div className="div-11">
                <div className="div-12">
                  <div className="newsletter">Newsletter</div>
                  <br/>
                  <div className="your-email">Your Email</div>
                  <input 
                    type="email" 
                    className="container-2" 
                    placeholder="Enter Your Email" 
                    required
                    value={Email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <div className="actions-2">
                    <button 
                      type="button" 
                      className="button-4" 
                      onClick={handleSubmit}
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
                <br></br>
                <br></br>
                <div className="terms-wrapper">
                  <div>Terms of Service</div>
                  <div>Privacy Policy</div>
                </div>
              </div>
            </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
